module.exports = __webpack_public_path__ + "media/images/realizacje/real14-09d973328a67b64702b71e4c4faaef99.png";